
export enum ShelfValues {
  Purchases,
  Creations,
  Imports,
  Favourites
}

export enum bookCategories {

  pdf = 'EBE',
  Ebook = 'EBE',
  OldElesson = 'ELE',
  NewElesson = 'ELE',
  Quiz = 'QZ',
  Media = 'MD',
  Object = 'OBJ',
  Webbook = 'EBE',
  Album = 'ALB'
}

export enum bookCategoeyEnums {
  pdf = 0,
  Ebook = 1,
  OldElesson = 2,
  NewElesson = 3,
  Quiz = 4,
  Media = 5,
  Object = 6,
  Webbook = 7,
  Album = 8
}


// WEBPACK FOOTER //
// ./src/app/shared/models/shelfEnums.ts